import { BaseAction } from './BaseAction';
import Locale from '../../utils/Locale';

export class TransferAccepted extends BaseAction {
    public static getTitle:Function = () => Locale.gettext('Transfer Accepted');
    public static getDescription:Function = () => Locale.gettext('A user accepted your ownership transfer');
    
}